import React, { useState, useRef } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Box, IconButton } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChatIcon from '@mui/icons-material/Chat';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import PersonIcon from '@mui/icons-material/Person';

const pulse = keyframes`
  0% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1.2);
  }
`;

const NavContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  background-color: #333;
  border-radius: 30px;
  padding: 8px 16px;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
  justify-content: space-between;
`;

const NavIconButton = styled(IconButton)`
  color: white;
  padding: 8px;
`;

const JJMuseButton = styled(IconButton)`
  background-color: ${props => props.isHolding ? '#9c27b0' : '#00C07F'} !important;
  color: white;
  padding: 12px;
  transform: scale(1.2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  animation: ${props => props.isHolding ? css`${pulse} 0.25s infinite` : 'none'};
  transition: background-color 0.3s;
  &:hover {
    background-color: ${props => props.isHolding ? '#7B1FA2' : '#00A06A'} !important;
  }
`;

const JJMuseIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  transform: rotate(10deg);
  color: white;
`;

const Navigation = ({ onNavigate }) => {
  const [isHolding, setIsHolding] = useState(false);
  const holdTimerRef = useRef(null);
  const modalTimerRef = useRef(null);
  const holdDuration = 250; // 250ms = 1/4 second for visual feedback (color change and pulsing)
  const modalLaunchDuration = 1000; // 1000ms = 1 second before launching the modal

  const handleMouseDown = () => {
    // Timer for visual feedback (color change and pulsing)
    holdTimerRef.current = setTimeout(() => {
      setIsHolding(true);
      console.log('Holding state activated, color should be purple');
    }, holdDuration);
    
    // Separate timer for launching the modal
    modalTimerRef.current = setTimeout(() => {
      console.log('Modal launch timer completed');
      onNavigate('jjmuse');
    }, modalLaunchDuration);
  };

  const handleMouseUp = () => {
    clearTimeout(holdTimerRef.current);
    clearTimeout(modalTimerRef.current);
    setIsHolding(false);
  };

  const handleTouchStart = () => {
    // Timer for visual feedback (color change and pulsing)
    holdTimerRef.current = setTimeout(() => {
      setIsHolding(true);
    }, holdDuration);
    
    // Separate timer for launching the modal
    modalTimerRef.current = setTimeout(() => {
      onNavigate('jjmuse');
    }, modalLaunchDuration);
  };

  const handleTouchEnd = () => {
    clearTimeout(holdTimerRef.current);
    clearTimeout(modalTimerRef.current);
    setIsHolding(false);
  };

  const handleNavigate = (route) => {
    // Only navigate on click if not the jjmuse route or if already holding
    if (route !== 'jjmuse') {
      onNavigate(route);
    }
  };

  return (
    <NavContainer>
      <NavIconButton onClick={() => handleNavigate('location')}>
        <LocationOnIcon style={{ color: 'white' }} />
      </NavIconButton>
      
      <NavIconButton onClick={() => handleNavigate('messages')}>
        <ChatIcon style={{ color: 'white' }} />
      </NavIconButton>
      
      <JJMuseButton 
        isHolding={isHolding}
        onClick={() => handleNavigate('jjmuse')}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{ backgroundColor: isHolding ? '#9c27b0' : '#00C07F' }}
      >
        <img src="/JustJamIcon.png" alt="JustJam" style={{ width: '30px', height: '30px' }} />
      </JJMuseButton>
      
      <NavIconButton onClick={() => handleNavigate('music')}>
        <MusicNoteIcon style={{ color: 'white' }} />
      </NavIconButton>
      
      <NavIconButton onClick={() => handleNavigate('profile')}>
        <PersonIcon style={{ color: 'white' }} />
      </NavIconButton>
    </NavContainer>
  );
};

export default Navigation;
